import React, { Component } from "react";
import "./DayCardGroup.css";

import DayCard from "./DayCard";

class DayCardGroup extends Component {
  getAppoinments = day => {
    let dayAppointments = this.props.appointments[day];
    let num = Object.keys(dayAppointments).length;
    return (
      <DayCard
        key={day}
        cardDate={day}
        numAppointment={num}
        appointments={dayAppointments}
      />
    );
  };

  render() {
    return (
      <div className="day-card-group">
        {Object.keys(this.props.appointments).map(this.getAppoinments)}
      </div>
    );
  }
}

export default DayCardGroup;
